import React from 'react';
import { useTranslation } from 'react-i18next';
import { CostCentreContribution } from 'types/coworker';
import { getShortCC } from 'utils/text';
import Text from '@ingka/text';
import classes from './CoworkerDetails.module.scss';

function CoworkerContribution({ title, contributions }: { title: string, contributions: CostCentreContribution[] }) {
    const { t } = useTranslation();

    return (
        contributions?.map(({ costCentre, evening, saturday, sunday }) => (
            <div key={costCentre} className={classes['info-item']}>
                <Text data-testid="coworker-contribution-CostCentre" textStyle="Label.M">{`${title} (${getShortCC(costCentre)})`}</Text>
                <Text data-testid="coworker-contribution-evening" textStyle="Body.M">{`${t('EVENINGS')} : ${evening} ${t('PER_WEEK')}`}</Text>
                <Text data-testid="coworker-contribution-saturday" textStyle="Body.M">{`${t('SATURDAY')} : ${saturday} ${t('PER_WEEK')}`}</Text>
                <Text data-testid="coworker-contribution-sunday" textStyle="Body.M">{`${t('SUNDAY')} : ${sunday} ${t('PER_WEEK')}`}</Text>
            </div>
        ))
    );
}

export default CoworkerContribution;
